import React, { useState } from "react";
import DropzoneThumbnail from "../dropzone/DropzoneThumbnail";
import { Modal } from "bootstrap"; // Import Bootstrap's modal functionality
import { toast } from "react-toastify";

const FamilyButtonAddModal = ({ type, answer = {} }) => {
  const [thumbnail, setThumbnail] = useState(null);

  const uploadFamilyMember = async (event) => {
    try {
      event.preventDefault();
      const formData = new FormData(event.target);
      formData.append("thumbnail", thumbnail);
      const response = null;

      if (response) {
        toast.success("Family member added");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error uploading family member:", error);
    }
  };

  const editFamilyMember = async (event) => {
    try {
      event.preventDefault();
      const formData = new FormData(event.target);
      formData.append("answer", answer._id);
      if (thumbnail) {
        formData.append("thumbnail", thumbnail);
      }
      const response = null;

      if (response) {
        toast.success("Family member updated!");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error update family member:", error);
    }
  };

  return (
    <form onSubmit={type == "add" ? uploadFamilyMember : editFamilyMember}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalToggleLabel">
              {type == "add" ? "Add Family Member" : "Edit Family Member"}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label htmlFor="familyMemberNumber" className="col-form-label">
                No.
              </label>
              <input
                type="text"
                className="form-control"
                id="familyMemberNumber"
                name="familyMemberNumber"
                placeholder="Number of family member"
                defaultValue={answer?.familyMemberNumber}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="thumbnail" className="col-form-label">
                Thumbnail
              </label>
              <DropzoneThumbnail
                onFileUpload={setThumbnail}
                accept={{
                  "image/*": [],
                }}
                title="thumbnail"
              />
            </div>
            <div className="mb-3">
              <label for="recipient-name" className="col-form-label">
                Name of family member
              </label>
              <input
                type="text"
                className="form-control truncate"
                id="recipient-name"
                placeholder="Name of family member"
                name="nameOfFamilyMember"
                defaultValue={answer?.nameOfFamilyMember}
              />
            </div>
            {/* <div className="mb-3">
                  <label for="recipient-name" className="col-form-label">
                    Recording
                  </label>
                  <DropzoneThumbnail
                    accept={{
                      "audio/*": [],
                    }}
                    onFileUpload={setAudio}
                    title="audio"
                  />
                </div> */}
          </div>
          <div className="modal-footer">
            <button
              // id="add-family-member"
              id={`${type}-family-member`}
              type="submit"
              className="btn-model"
            >
              {type == "add" ? "Add family member" : "Edit family member"}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FamilyButtonAddModal;
